var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _rect, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _g, _g2, _g3, _path37, _path38, _path39, _path40, _path41, _g4, _path42, _path43, _path44, _g5, _path45, _path46, _path47, _polygon, _polygon2, _path48, _polygon3, _polygon4, _line, _path49, _line2, _path50, _line3, _line4, _line5, _path51, _line6, _path52, _line7, _circle, _circle2, _path53, _path54, _rect2, _circle3, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgServerError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 865.76,
    height: 682.89,
    viewBox: "0 0 865.76 682.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M617.16,110.36A338.46,338.46,0,0,0,402.61,34.08C214.9,34.08,62.74,186.25,62.74,374a341.8,341.8,0,0,0,6.71,67.56Z",
    fill: "#00A3FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M639.18,97.89,84.12,450.69a339.71,339.71,0,0,0,81.35,134.45L747.25,364.83q.46-8.91.46-17.94A339,339,0,0,0,639.18,97.89Z",
    fill: "#00A3FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M239.51,561a338.63,338.63,0,0,0,228,87.8C636.68,648.81,777,525.16,803,363.3,677,407.26,353.81,520.09,239.51,561Z",
    fill: "#00A3FF"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    style: {
      isolation: "isolate"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M617.16,110.36A338.46,338.46,0,0,0,402.61,34.08C214.9,34.08,62.74,186.25,62.74,374a341.8,341.8,0,0,0,6.71,67.56Z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M639.18,97.89,84.12,450.69a339.71,339.71,0,0,0,81.35,134.45L747.25,364.83q.46-8.91.46-17.94A339,339,0,0,0,639.18,97.89Z",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M239.51,561a338.63,338.63,0,0,0,228,87.8C636.68,648.81,777,525.16,803,363.3,677,407.26,353.81,520.09,239.51,561Z",
    fill: "#fff"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M202.13,568.14a6.79,6.79,0,0,1-2.84-2.31,6.1,6.1,0,0,1-1.11-3.31h2.55a4.91,4.91,0,0,0,1.56,3.09,5.61,5.61,0,0,0,4,1.32,5.71,5.71,0,0,0,3.88-1.25,4.06,4.06,0,0,0,1.43-3.2,3.78,3.78,0,0,0-.79-2.5,4.87,4.87,0,0,0-2-1.41,31.88,31.88,0,0,0-3.25-1,28.39,28.39,0,0,1-3.83-1.27,6.14,6.14,0,0,1-2.41-1.94,5.69,5.69,0,0,1-1-3.55,6,6,0,0,1,1-3.33,6.5,6.5,0,0,1,2.73-2.29,9.26,9.26,0,0,1,4-.83,8.37,8.37,0,0,1,5.39,1.64,6.16,6.16,0,0,1,2.37,4.22h-2.62a4.39,4.39,0,0,0-1.63-2.63,6.38,6.38,0,0,0-7.34,0,3.8,3.8,0,0,0-1.45,3.15,3.64,3.64,0,0,0,.79,2.45,5.06,5.06,0,0,0,2,1.41,28.35,28.35,0,0,0,3.23,1,30.31,30.31,0,0,1,3.79,1.29,6.18,6.18,0,0,1,2.45,2,5.66,5.66,0,0,1,1,3.52,6.27,6.27,0,0,1-.89,3.21,6.6,6.6,0,0,1-2.66,2.45,8.9,8.9,0,0,1-4.21.93A10,10,0,0,1,202.13,568.14Z",
    fill: "#2f2e41"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M235.71,560.24H220.09a7.49,7.49,0,0,0,1,3.66,6.05,6.05,0,0,0,2.45,2.29,7.14,7.14,0,0,0,3.31.78,6.65,6.65,0,0,0,4-1.14,5.31,5.31,0,0,0,2.12-3.07h2.56a8.05,8.05,0,0,1-2.95,4.5,9,9,0,0,1-5.68,1.74,9.42,9.42,0,0,1-4.76-1.19,8.37,8.37,0,0,1-3.29-3.38,10.47,10.47,0,0,1-1.19-5.12,10.83,10.83,0,0,1,1.17-5.14,8.1,8.1,0,0,1,3.28-3.38,9.68,9.68,0,0,1,4.79-1.17,9.25,9.25,0,0,1,4.71,1.17,8,8,0,0,1,3.1,3.16,8.93,8.93,0,0,1,1.09,4.39A18.18,18.18,0,0,1,235.71,560.24Zm-3.22-5.55a5.69,5.69,0,0,0-2.4-2.24,7.25,7.25,0,0,0-3.31-.76,6.56,6.56,0,0,0-4.59,1.72,6.83,6.83,0,0,0-2.1,4.87h13.24A6.77,6.77,0,0,0,232.49,554.69Z",
    fill: "#2f2e41"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M245,550.51a7.84,7.84,0,0,1,4-1v2.52h-.65a6.11,6.11,0,0,0-4.21,1.41q-1.59,1.41-1.59,4.73v10.52H240.2V549.89h2.41v3.35A6,6,0,0,1,245,550.51Z",
    fill: "#2f2e41"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M259.38,566.38l6.34-16.49h2.56l-7.56,18.84H258l-7.56-18.84H253Z",
    fill: "#2f2e41"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M271.52,545.82a1.7,1.7,0,0,1-.52-1.27,1.65,1.65,0,0,1,.52-1.26,1.79,1.79,0,0,1,2.48,0,1.65,1.65,0,0,1,.52,1.26,1.7,1.7,0,0,1-.52,1.27,1.74,1.74,0,0,1-2.48,0Zm2.45,4.07v18.84h-2.42V549.89Z",
    fill: "#2f2e41"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M279.52,554.19a8.32,8.32,0,0,1,3.24-3.38,10.24,10.24,0,0,1,10.47.53,7.83,7.83,0,0,1,2.92,4.69h-2.59a5.31,5.31,0,0,0-2.09-3.19,6.62,6.62,0,0,0-4-1.15,6.87,6.87,0,0,0-3.42.86,6,6,0,0,0-2.39,2.57,10.46,10.46,0,0,0,0,8.4,6,6,0,0,0,2.39,2.59,6.87,6.87,0,0,0,3.42.86,6.62,6.62,0,0,0,4-1.16,5.29,5.29,0,0,0,2.09-3.22h2.59a7.93,7.93,0,0,1-2.93,4.65,9.06,9.06,0,0,1-5.73,1.76,9.26,9.26,0,0,1-4.73-1.19,8.32,8.32,0,0,1-3.24-3.38,11.79,11.79,0,0,1,0-10.24Z",
    fill: "#2f2e41"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M317.57,560.24H301.94a7.6,7.6,0,0,0,1,3.66,6,6,0,0,0,2.45,2.29,7.11,7.11,0,0,0,3.31.78,6.65,6.65,0,0,0,3.95-1.14,5.36,5.36,0,0,0,2.12-3.07h2.55a8,8,0,0,1-2.95,4.5,9,9,0,0,1-5.67,1.74,9.42,9.42,0,0,1-4.76-1.19,8.39,8.39,0,0,1-3.3-3.38,10.58,10.58,0,0,1-1.19-5.12,10.71,10.71,0,0,1,1.18-5.14,8.14,8.14,0,0,1,3.27-3.38,9.72,9.72,0,0,1,4.8-1.17,9.25,9.25,0,0,1,4.71,1.17,8,8,0,0,1,3.1,3.16,8.93,8.93,0,0,1,1.09,4.39C317.64,559.17,317.61,559.81,317.57,560.24Zm-3.23-5.55a5.61,5.61,0,0,0-2.39-2.24,7.3,7.3,0,0,0-3.32-.76,6.55,6.55,0,0,0-4.58,1.72,6.88,6.88,0,0,0-2.11,4.87h13.25A6.68,6.68,0,0,0,314.34,554.69Z",
    fill: "#2f2e41"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M333.82,544.61v15.18c0,2.4.56,4.17,1.7,5.32a6.29,6.29,0,0,0,4.68,1.72,6.21,6.21,0,0,0,4.64-1.71c1.11-1.14,1.67-2.91,1.67-5.33V544.61h2.41v15.15q0,4.59-2.43,6.9a9.83,9.83,0,0,1-12.66,0q-2.43-2.31-2.43-6.9V544.61Z",
    fill: "#2f2e41"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M368.66,551.64a8.08,8.08,0,0,1,2.13,6.05v11h-2.38V558a6.61,6.61,0,0,0-1.53-4.69,5.49,5.49,0,0,0-4.19-1.62,5.69,5.69,0,0,0-4.35,1.73,7.15,7.15,0,0,0-1.62,5.07v10.28h-2.41V549.89h2.41v3.21a6.17,6.17,0,0,1,2.59-2.64,7.88,7.88,0,0,1,3.83-.91A7.55,7.55,0,0,1,368.66,551.64Z",
    fill: "#2f2e41"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M376.19,554.19a8.25,8.25,0,0,1,3.21-3.38,9,9,0,0,1,4.64-1.19,8.44,8.44,0,0,1,4.64,1.24,7.23,7.23,0,0,1,2.81,3.17v-4.14h2.42v18.84h-2.42v-4.18a7.56,7.56,0,0,1-2.84,3.19A8.37,8.37,0,0,1,384,569a9,9,0,0,1-4.61-1.2,8.41,8.41,0,0,1-3.21-3.42,11.86,11.86,0,0,1,0-10.19Zm14.37,1.12a6.65,6.65,0,0,0-2.54-2.66,6.87,6.87,0,0,0-3.53-.93,7.14,7.14,0,0,0-3.59.9,6.34,6.34,0,0,0-2.5,2.6,8.48,8.48,0,0,0-.91,4.06,8.58,8.58,0,0,0,.91,4.05,6.43,6.43,0,0,0,2.5,2.66,7,7,0,0,0,3.59.91A6.87,6.87,0,0,0,388,566a6.65,6.65,0,0,0,2.54-2.66,9.07,9.07,0,0,0,0-8Z",
    fill: "#2f2e41"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M406.12,566.38l6.34-16.49H415l-7.56,18.84h-2.72l-7.56-18.84h2.59Z",
    fill: "#2f2e41"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M418.35,554.19a8.29,8.29,0,0,1,3.2-3.38,9,9,0,0,1,4.64-1.19,8.42,8.42,0,0,1,4.64,1.24,7.23,7.23,0,0,1,2.81,3.17v-4.14h2.42v18.84h-2.42v-4.18a7.43,7.43,0,0,1-2.84,3.19,8.37,8.37,0,0,1-4.64,1.26,9,9,0,0,1-4.61-1.2,8.46,8.46,0,0,1-3.2-3.42,11.77,11.77,0,0,1,0-10.19Zm14.36,1.12a6.63,6.63,0,0,0-2.53-2.66,6.93,6.93,0,0,0-3.54-.93,7.17,7.17,0,0,0-3.59.9,6.4,6.4,0,0,0-2.5,2.6,8.48,8.48,0,0,0-.91,4.06,8.58,8.58,0,0,0,.91,4.05,6.5,6.5,0,0,0,2.5,2.66,7.07,7.07,0,0,0,3.59.91,6.93,6.93,0,0,0,3.54-.93,6.63,6.63,0,0,0,2.53-2.66,9.07,9.07,0,0,0,0-8Z",
    fill: "#2f2e41"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M441.54,545.82a1.73,1.73,0,0,1-.51-1.27,1.68,1.68,0,0,1,.51-1.26,1.8,1.8,0,0,1,2.49,0,1.68,1.68,0,0,1,.51,1.26,1.73,1.73,0,0,1-.51,1.27,1.75,1.75,0,0,1-2.49,0Zm2.45,4.07v18.84h-2.41V549.89Z",
    fill: "#2f2e41"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M451.89,543.2v25.53h-2.41V543.2Z",
    fill: "#2f2e41"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M457.43,554.19a8.25,8.25,0,0,1,3.21-3.38,9,9,0,0,1,4.64-1.19,8.44,8.44,0,0,1,4.64,1.24,7.36,7.36,0,0,1,2.81,3.17v-4.14h2.41v18.84h-2.41v-4.18a7.51,7.51,0,0,1-2.85,3.19,8.37,8.37,0,0,1-4.64,1.26,8.92,8.92,0,0,1-4.6-1.2,8.41,8.41,0,0,1-3.21-3.42,11.77,11.77,0,0,1,0-10.19Zm14.37,1.12a6.72,6.72,0,0,0-2.54-2.66,6.93,6.93,0,0,0-3.54-.93,7.1,7.1,0,0,0-3.58.9,6.27,6.27,0,0,0-2.5,2.6,8.48,8.48,0,0,0-.92,4.06,8.58,8.58,0,0,0,.92,4.05,6.37,6.37,0,0,0,2.5,2.66,7,7,0,0,0,3.58.91,6.93,6.93,0,0,0,3.54-.93,6.72,6.72,0,0,0,2.54-2.66,9.07,9.07,0,0,0,0-8Z",
    fill: "#2f2e41"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M485.92,550.86a8.39,8.39,0,0,1,4.61-1.24,8.93,8.93,0,0,1,4.62,1.19,8.26,8.26,0,0,1,3.19,3.38,11.86,11.86,0,0,1,0,10.19,8.41,8.41,0,0,1-3.21,3.42,8.94,8.94,0,0,1-4.6,1.2,8.5,8.5,0,0,1-4.64-1.22,7.35,7.35,0,0,1-2.85-3.19v4.14h-2.38V543.2H483v10.87A7.65,7.65,0,0,1,485.92,550.86Zm10.21,4.36a6.34,6.34,0,0,0-2.5-2.6,7.17,7.17,0,0,0-3.59-.9,6.92,6.92,0,0,0-3.53.93,6.65,6.65,0,0,0-2.54,2.66,9.07,9.07,0,0,0,0,8,6.65,6.65,0,0,0,2.54,2.66,6.92,6.92,0,0,0,3.53.93,7.07,7.07,0,0,0,3.59-.91,6.43,6.43,0,0,0,2.5-2.66,8.58,8.58,0,0,0,.92-4.05A8.48,8.48,0,0,0,496.13,555.22Z",
    fill: "#2f2e41"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M506.36,543.2v25.53h-2.42V543.2Z",
    fill: "#2f2e41"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M528.81,560.24H513.19a7.59,7.59,0,0,0,1,3.66,6.05,6.05,0,0,0,2.45,2.29A7.14,7.14,0,0,0,520,567a6.63,6.63,0,0,0,3.95-1.14,5.31,5.31,0,0,0,2.12-3.07h2.56a8,8,0,0,1-3,4.5A9,9,0,0,1,520,569a9.45,9.45,0,0,1-4.76-1.19,8.37,8.37,0,0,1-3.29-3.38,10.47,10.47,0,0,1-1.19-5.12,10.83,10.83,0,0,1,1.17-5.14,8.1,8.1,0,0,1,3.28-3.38,9.68,9.68,0,0,1,4.79-1.17,9.19,9.19,0,0,1,4.71,1.17A8.07,8.07,0,0,1,527.8,554a9,9,0,0,1,1.08,4.39A18.18,18.18,0,0,1,528.81,560.24Zm-3.22-5.55a5.69,5.69,0,0,0-2.4-2.24,7.25,7.25,0,0,0-3.31-.76,6.59,6.59,0,0,0-4.59,1.72,6.92,6.92,0,0,0-2.1,4.87h13.24A6.59,6.59,0,0,0,525.59,554.69Z",
    fill: "#2f2e41"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M289.89,414H230.16v26.42a27.77,27.77,0,0,1,10.72-6.89,40.75,40.75,0,0,1,14.93-2.68q14.35,0,23.83,6.51a38.25,38.25,0,0,1,13.88,16.84,56.52,56.52,0,0,1,4.41,22.4q0,22.41-12.64,35.52t-35.61,13.11q-15.31,0-26.61-5.26a40.71,40.71,0,0,1-17.42-14.65,42.31,42.31,0,0,1-6.7-21.63h32a17.31,17.31,0,0,0,5.55,9.86q4.41,3.92,12.06,3.92,9,0,13.41-5.74t4.4-15.32q0-9.37-4.6-14.36t-13.4-5a17.41,17.41,0,0,0-10.72,3.15,14.74,14.74,0,0,0-5.55,8.33H200.48V385.24h89.41Z",
    fill: "#2f2e41"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M328.65,401.52q12.74-19,41.07-19t41.07,19q12.72,18.94,12.73,51.88,0,33.32-12.73,52.26t-41.07,19q-28.34,0-41.07-19T315.92,453.4Q315.92,420.48,328.65,401.52Zm58.49,22.11q-4.22-10.44-17.42-10.44T352.3,423.63q-4.21,10.42-4.21,29.77a125.31,125.31,0,0,0,1.53,21.54,27.51,27.51,0,0,0,6.22,13.78q4.7,5.26,13.88,5.27t13.88-5.27a27.51,27.51,0,0,0,6.22-13.78,125.31,125.31,0,0,0,1.53-21.54Q391.35,434.07,387.14,423.63Z",
    fill: "#2f2e41"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M455.3,393.28q12.63-11.1,34.27-11.1,14.35,0,24.6,5a35.26,35.26,0,0,1,20.77,32.93q0,12.63-6.32,20.58a31.92,31.92,0,0,1-14.74,10.81v.77a34.57,34.57,0,0,1,17.23,12.06q6.32,8.43,6.32,21.63a39.93,39.93,0,0,1-5.46,21,37.28,37.28,0,0,1-15.89,14.26q-10.44,5.18-24.79,5.17-23,0-36.66-11.3T440.17,481H472q.19,8.41,4.79,13.3t13.4,4.88q7.47,0,11.58-4.3c2.75-2.88,4.12-6.67,4.12-11.4q0-9.18-5.84-13.3T481.33,466h-6.12V439.42h6.12q9.76,0,15.8-3.35t6-12q0-6.9-3.83-10.72t-10.53-3.83q-7.28,0-10.82,4.4a19.72,19.72,0,0,0-4.11,10.91h-32Q442.66,404.4,455.3,393.28Z",
    fill: "#2f2e41"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M175.26,556.89a89.11,89.11,0,0,1-9.62-.5,74.2,74.2,0,0,1-29.89-9.69A63.12,63.12,0,0,1,105,488.23a43.62,43.62,0,0,1,15.46-31.05c13.64-11.71,33.87-16.13,48.43-17.77a167,167,0,0,1,28.52-.78,1.5,1.5,0,1,1-.24,3c-.49,0-49.69-3.69-74.76,17.84a40.73,40.73,0,0,0-14.42,29,60.12,60.12,0,0,0,29.33,55.67c19.17,11.31,43.13,12.85,71.23,4.58a155,155,0,0,0,43.16-20.59l92.15-62.46c1.25-1.09,15.27-13,39.42-22.42a164.82,164.82,0,0,1,45.13-10.71,169.93,169.93,0,0,1,58.42,5h0L600.6,471.19c1.06.25,28.37,6.42,50.07-7.93,13.71-9.07,22.42-24.36,25.87-45.44a84.11,84.11,0,0,0-3.84-34.66c-8.14-24.06-26.49-39.37-54.55-45.51a108.73,108.73,0,0,0-32.77-1.87c-6.35.56-15,1.09-24.68,1.09-28.8,0-67.07-4.72-83.51-27.57-10.91-15.16-10.61-36.2.88-62.54a1.5,1.5,0,0,1,2.75,1.19c-11,25.31-11.44,45.36-1.2,59.6,9.12,12.67,26.54,20.88,51.78,24.41,21.2,3,42.76,1.79,53.72.83a111.74,111.74,0,0,1,33.67,1.94c16,3.5,29.21,10.08,39.16,19.54a68,68,0,0,1,17.62,28.05,85.39,85.39,0,0,1,3.93,36c-3.6,22-12.75,38-27.2,47.49-23.14,15.29-51.26,8.62-52.44,8.33l-.07,0L486,440.41c-43.34-11.27-79.15-3.2-101.56,5.57-24.33,9.51-38.59,21.86-38.73,22l-.14.12-92.23,62.51a158,158,0,0,1-44,21A121.07,121.07,0,0,1,175.26,556.89Z",
    fill: "#fff"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M175.26,557.39a89.88,89.88,0,0,1-9.67-.51,74.46,74.46,0,0,1-30.09-9.75,63.63,63.63,0,0,1-31-58.93,44.13,44.13,0,0,1,15.63-31.4c13.74-11.79,34.07-16.24,48.7-17.89a166.27,166.27,0,0,1,28.62-.77,1.94,1.94,0,0,1,1.36.69,2,2,0,0,1,.48,1.46,2.06,2.06,0,0,1-.7,1.36,2,2,0,0,1-1.46.47c-.49,0-49.51-3.65-74.4,17.72a40.3,40.3,0,0,0-14.25,28.65,59.64,59.64,0,0,0,29.09,55.2c19.05,11.23,42.88,12.76,70.84,4.54a154.75,154.75,0,0,0,43-20.54l92.15-62.46c1.46-1.27,15.4-13,39.51-22.46A165.47,165.47,0,0,1,428.33,432a170.61,170.61,0,0,1,58.58,5l113.83,33.68c1.12.26,28.11,6.38,49.66-7.87,13.59-9,22.22-24.16,25.65-45.1a84.19,84.19,0,0,0-3.83-34.42c-8.07-23.88-26.3-39.08-54.18-45.18a108,108,0,0,0-32.61-1.86c-8.28.72-16.6,1.09-24.73,1.09-29.17,0-67.4-4.82-83.92-27.78-11-15.31-10.73-36.52.83-63a2,2,0,1,1,3.66,1.59c-11,25.13-11.38,45-1.24,59.11,9,12.55,26.34,20.7,51.44,24.21,21.14,3,42.66,1.78,53.61.82a112.4,112.4,0,0,1,33.82,1.95c16.12,3.52,29.37,10.14,39.4,19.67a68.7,68.7,0,0,1,17.75,28.25,86.1,86.1,0,0,1,4,36.19c-3.63,22.12-12.85,38.22-27.42,47.84-23.34,15.42-51.65,8.69-52.84,8.39L485.87,440.89a163.2,163.2,0,0,0-101.24,5.55c-24.22,9.47-38.44,21.78-38.58,21.9l-.19.15L253.63,531a158.55,158.55,0,0,1-44.14,21.06A122,122,0,0,1,175.26,557.39ZM188.1,438.86a171.47,171.47,0,0,0-19.19,1.05c-14.5,1.63-34.62,6-48.17,17.65a43.19,43.19,0,0,0-15.29,30.71,62.65,62.65,0,0,0,30.56,58,73.48,73.48,0,0,0,29.68,9.62c13.17,1.42,27.91-.2,43.52-4.79a157.53,157.53,0,0,0,43.86-20.93l92.23-62.51.09-.07c.15-.13,14.5-12.55,38.87-22.08,22.49-8.79,58.41-16.89,101.88-5.58L599.93,473.6c1.23.3,29.12,6.93,52.1-8.25,14.32-9.46,23.4-25.32,27-47.16a84.86,84.86,0,0,0-3.91-35.72,67.67,67.67,0,0,0-17.49-27.84c-9.89-9.4-23-15.93-38.92-19.42a111.49,111.49,0,0,0-33.53-1.92c-11,1-32.59,2.14-53.83-.83-25.38-3.55-42.92-11.84-52.11-24.62-10.36-14.39-10-34.61,1.14-60.09a1,1,0,0,0,0-.76,1,1,0,0,0-.53-.55,1,1,0,0,0-1.31.52c-11.42,26.16-11.73,47-.93,62,16.27,22.62,54.17,27.36,83.1,27.36,8.1,0,16.39-.37,24.64-1.09a109.09,109.09,0,0,1,32.92,1.89c28.24,6.17,46.71,21.6,54.91,45.83A85.44,85.44,0,0,1,677,417.89c-3.48,21.24-12.26,36.64-26.09,45.78-21.9,14.49-49.31,8.28-50.46,8L486.69,438a169.4,169.4,0,0,0-58.27-5,164.24,164.24,0,0,0-45,10.68c-24,9.39-37.78,21-39.27,22.33L252,528.52a155.6,155.6,0,0,1-43.3,20.66c-28.23,8.31-52.33,6.75-71.63-4.63a60.61,60.61,0,0,1-29.57-56.14A41.22,41.22,0,0,1,122,459.08c25.2-21.64,74.64-18,75.13-18a1,1,0,0,0,.73-.23,1,1,0,0,0,.35-.68,1,1,0,0,0-.24-.73,1,1,0,0,0-.68-.35C197.27,439.13,193.72,438.86,188.1,438.86Z",
    fill: "#00A3FF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 482.11,
    y: 160.87,
    width: 94.36,
    height: 167.04,
    rx: 32.14,
    transform: "translate(-53.52 259) rotate(-26.22)",
    fill: "#2f2e41"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 482.11,
    y: 160.87,
    width: 94.36,
    height: 167.04,
    rx: 32.14,
    transform: "translate(-53.52 259) rotate(-26.22)",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M528.58,168.25c-2.61-5.19-4.92-9.85-4.92-9.85s9.76-6,5.52-16.47-16.08-33.7-16.08-33.7l-23-.21-13.14,25.43L501.49,182a15.17,15.17,0,0,0,20.06,6.78h0a15.18,15.18,0,0,0,7.16-20.23C528.67,168.42,528.62,168.34,528.58,168.25Z",
    fill: "#f9b499"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M523.62,158.32a28.19,28.19,0,0,1-15.69,1.88s6.89,6,16.9.67Z",
    fill: "#f7a48b"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M465.8,149.14,466,149a61,61,0,0,1-1.83-5.9c-4.59-23.9,12.19-36.78,15.89-38.54,4-1.9,9.87-7.39,25-1.71a25.08,25.08,0,0,1,6.45,3.51,25.15,25.15,0,0,1,9,7.41,14.77,14.77,0,0,1,2.71,5c-.07,0-1.14-1.83-3.35-4.39a26,26,0,0,0-4.32-4.07,21.34,21.34,0,0,1,4.54,12.2l-2.44-.76L500.86,125c-.73-4.58-4.86-8.74-6.95-10.59h-.13c4.3,16.68-11.75,26.28-11.75,26.28l13.07,28.74C473.18,174.59,465.8,149.14,465.8,149.14Z",
    fill: "#2f2e41"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M488.48,157.1a4.71,4.71,0,0,1-5.68,1.82,7,7,0,0,1-4-4.83,5.21,5.21,0,0,1,.29-3.82,5.42,5.42,0,0,1,4.71-1.91Z",
    fill: "#f9b499"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M468.09,117.26a6.78,6.78,0,0,0,2.78-9.17,6.86,6.86,0,0,0-1.26-1.67c-2.81-2.71-7.64-2.48-10.84-.14a15.06,15.06,0,0,0-5.3,10.12,13,13,0,0,0,.54,6.68,6.78,6.78,0,0,0,4.87,4.3,7.32,7.32,0,0,0,6.58-2.9,21.7,21.7,0,0,0,3.31-6.78",
    fill: "#2f2e41"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M455,116.51a9.43,9.43,0,0,1-.87,4.65A19.21,19.21,0,0,0,452.9,126a6.12,6.12,0,0,0,.42,2.81,3.79,3.79,0,0,0,4.88,2.25,7.66,7.66,0,0,0,2.53-1.36,12,12,0,0,0,3-3.88,19.64,19.64,0,0,0,1.35-4.44,3.44,3.44,0,0,1,0,1.28,11.28,11.28,0,0,1-.93,3.36,12,12,0,0,1-3.08,4.18,7.8,7.8,0,0,1-2.71,1.52,4.78,4.78,0,0,1-3.41-.13,4.62,4.62,0,0,1-2.31-2.51,6.64,6.64,0,0,1-.43-3.12,18,18,0,0,1,1.44-5,21.57,21.57,0,0,0,1.07-3.24A10.83,10.83,0,0,1,455,116.51Z",
    fill: "#2f2e41"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M477.64,193.42S537.25,302.84,547.16,315l80.51-35.79L578.9,195.44a53.93,53.93,0,0,0-42.73-26.85h-.57C516.46,167.34,474.75,188.09,477.64,193.42Z",
    fill: "#00A3FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M543.65,207.09a3.76,3.76,0,1,1-3.76-3.75h0A3.75,3.75,0,0,1,543.65,207.09Z",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M551.15,223.2a3.75,3.75,0,1,1-3.75-3.75h0A3.75,3.75,0,0,1,551.15,223.2Z",
    fill: "#fff"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 556.41,
    cy: 238.88,
    r: 3.75,
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "547.16 275.12 608.66 246.53 605.37 240.9 547.16 275.12",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M612.42,283.86s125.69,24.64,128.33,38.53S738,459,738,459l-36.31.73-3.94-106.91L547.16,313.43Z",
    fill: "#00A3FF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M612.42,283.86s125.69,24.64,128.33,38.53S738,459,738,459l-36.31.73-3.94-106.91L547.16,313.43Z",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M704.17,161.49v-.08a193.21,193.21,0,0,0,18.61-8.86c8.13-4.91,7.75-5.64,7-6.5-2-2.29-14.7,8.13-13.25,4.26s17-10.83,14.9-13.19c-2.82-3-16,8.13-17.13,8.95s-2.45-.81-1.35-1.53c1.6-1,18-12.29,15.31-15.27-1.52-1.65-4.23,1.36-4.23,1.36s-14.62,11.65-15.86,10.2,7.08-8.6,10.08-10.84,3.1-4.47,1-5c-1.35-.35-10.7,6.19-13.54,8.44s-10.76,8.56-9.42,2.3,0-11.57-1.36-12.76-3.5.27-3.07,2.21a23.24,23.24,0,0,1-.12,6.45,15.43,15.43,0,0,1-1.48,5c-.89,1.82-1.73,3.31-2.48,4.57a8.94,8.94,0,0,0-1.11,6.68c1,3.34,13.17,15.18,13.17,15.18Z",
    fill: "#ff725e"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M704.17,161.49v-.08a193.21,193.21,0,0,0,18.61-8.86c8.13-4.91,7.75-5.64,7-6.5-2-2.29-14.7,8.13-13.25,4.26s17-10.83,14.9-13.19c-2.82-3-16,8.13-17.13,8.95s-2.45-.81-1.35-1.53c1.6-1,18-12.29,15.31-15.27-1.52-1.65-4.23,1.36-4.23,1.36s-14.62,11.65-15.86,10.2,7.08-8.6,10.08-10.84,3.1-4.47,1-5c-1.35-.35-10.7,6.19-13.54,8.44s-10.76,8.56-9.42,2.3,0-11.57-1.36-12.76-3.5.27-3.07,2.21a23.24,23.24,0,0,1-.12,6.45,15.43,15.43,0,0,1-1.48,5c-.89,1.82-1.73,3.31-2.48,4.57a8.94,8.94,0,0,0-1.11,6.68c1,3.34,13.17,15.18,13.17,15.18Z",
    fill: "#f9b499"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M545.73,170.88c2.82,2.1,81.59,4.8,81.59,4.8l51.39-29,20.58,19.66s-60,40.36-66.67,41.77-55.39,0-55.39,0Z",
    fill: "#00A3FF"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M675.78,148l20.9,20.43a4.25,4.25,0,0,0,5.16.53l.14-.09a3.53,3.53,0,0,0,1.08-5.14,4.81,4.81,0,0,0-.42-.48l-21.06-20.34a4.22,4.22,0,0,0-4.87-.66h0a3.53,3.53,0,0,0-1.51,5A3.73,3.73,0,0,0,675.78,148Z",
    fill: "#00A3FF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M675.78,148l20.9,20.43a4.25,4.25,0,0,0,5.16.53l.14-.09a3.53,3.53,0,0,0,1.08-5.14,4.81,4.81,0,0,0-.42-.48l-21.06-20.34a4.22,4.22,0,0,0-4.87-.66h0a3.53,3.53,0,0,0-1.51,5A3.73,3.73,0,0,0,675.78,148Z",
    fill: "#fff",
    opacity: 0.5,
    style: {
      isolation: "isolate"
    }
  }), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M591.36,208.49a91.66,91.66,0,0,0-13.21-24.39c-5.22-7-18.33-12.58-27.09-12.19,12.52,5.65,29.05,22.6,35.05,36.69Z"
  }))), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M480.11,189.29c-.5-2.47-50.93,37.72-71.44,54.47a24.21,24.21,0,0,0-8.91,18.8h0A24.28,24.28,0,0,0,424,286.84H483.5V256.68H444.78l49.7-32.75Z",
    fill: "#00A3FF"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M492.27,283.49v-.09a188.31,188.31,0,0,0,20.51,2c9.49,0,9.56-.84,9.37-1.95-.5-3-16.76-.66-13.55-3.18s20.21-.54,19.56-3.63c-.85-4.07-17.83-1.29-19.29-1.15s-1.68-2-.37-2c1.9,0,21.79-1.22,21-5.19-.45-2.2-4.32-1-4.32-1s-18.54,2.45-18.85.57,10.52-3.73,14.21-4.07,5-2.22,3.47-3.71c-1-1-12.37-.22-16,.22s-13.63,1.8-9.25-2.87,6-9.92,5.41-11.64a2,2,0,0,0-3.76.31,23.8,23.8,0,0,1-3.44,5.42,15.29,15.29,0,0,1-3.82,3.49c-1.71,1.1-3.2,2-4.49,2.65a9,9,0,0,0-4.39,5.14c-.84,3.42,3.46,19.8,3.46,19.8Z",
    fill: "#ff725e"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M492.27,283.49v-.09a188.31,188.31,0,0,0,20.51,2c9.49,0,9.56-.84,9.37-1.95-.5-3-16.76-.66-13.55-3.18s20.21-.54,19.56-3.63c-.85-4.07-17.83-1.29-19.29-1.15s-1.68-2-.37-2c1.9,0,21.79-1.22,21-5.19-.45-2.2-4.32-1-4.32-1s-18.54,2.45-18.85.57,10.52-3.73,14.21-4.07,5-2.22,3.47-3.71c-1-1-12.37-.22-16,.22s-13.63,1.8-9.25-2.87,6-9.92,5.41-11.64a2,2,0,0,0-3.76.31,23.8,23.8,0,0,1-3.44,5.42,15.29,15.29,0,0,1-3.82,3.49c-1.71,1.1-3.2,2-4.49,2.65a9,9,0,0,0-4.39,5.14c-.84,3.42,3.46,19.8,3.46,19.8Z",
    fill: "#f9b499"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M449.88,253.33c-.19-4.8-4.06-9-8.55-10.55s-10.6-.15-15.07,1.63c7.12,2.07,14.42,6.08,18.41,12.35Z"
  }))), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M480.16,256.65l.78,27.92a3.8,3.8,0,0,0,3.43,3.54h.18a4,4,0,0,0,4.51-3.16,4,4,0,0,0,0-.6l-1-27.94a3.78,3.78,0,0,0-3.18-3.48h0a4,4,0,0,0-4.72,2.85A3.66,3.66,0,0,0,480.16,256.65Z",
    fill: "#00A3FF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M480.16,256.65l.78,27.92a3.8,3.8,0,0,0,3.43,3.54h.18a4,4,0,0,0,4.51-3.16,4,4,0,0,0,0-.6l-1-27.94a3.78,3.78,0,0,0-3.18-3.48h0a4,4,0,0,0-4.72,2.85A3.66,3.66,0,0,0,480.16,256.65Z",
    fill: "#fff",
    opacity: 0.5,
    style: {
      isolation: "isolate"
    }
  }), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M716.62,274.54,669.48,326.7l-26.33-18.58,43.35-51.74L572.07,316.85a23.85,23.85,0,0,1-31.16-8.55h0a23.87,23.87,0,0,1,7.58-32.88c.76-.47,1.55-.9,2.35-1.29L674.52,215A41.84,41.84,0,0,1,726,227.51h0C737.69,243,731.52,259.38,716.62,274.54Z",
    fill: "#00A3FF"
  })), /*#__PURE__*/React.createElement("polyline", {
    points: "653.12 274.13 685.65 256.95 702.49 236.56 653.12 274.13",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M637.07,315.34l40.28,37a104.91,104.91,0,0,0-12.54-41.31,3.8,3.8,0,0,0-1.86-1.68l-9.84-4.24a5.57,5.57,0,0,0-5.47,1A125.9,125.9,0,0,0,637.07,315.34Z",
    fill: "#2f2e41"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "637.07 315.34 633.61 319.44 674.23 356.08 677.35 352.38 637.07 315.34",
    fill: "#00A3FF"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "638.55 313.99 659.97 286.51 689.85 305.47 669.36 329.89 638.55 313.99",
    fill: "#2f2e41"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M705.89,492.45l54.67-2.28a104.83,104.83,0,0,0-38.08-20.35,3.83,3.83,0,0,0-2.5.13l-10,4a5.58,5.58,0,0,0-3.15,4.58A124.83,124.83,0,0,0,705.89,492.45Z",
    fill: "#2f2e41"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "705.89 492.45 706.34 497.8 760.97 494.99 760.56 490.17 705.89 492.45",
    fill: "#00A3FF"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "705.98 490.45 698.71 455.56 740.13 448.98 739.01 479.91 705.98 490.45",
    fill: "#2f2e41"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 543.21,
    y1: 309.1,
    x2: 544.54,
    y2: 308.4,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M547.17,307l138.65-73.26a7.06,7.06,0,0,1,9.6,3.07l1.28,2.56",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeDasharray: "2.97 2.97"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 697.37,
    y1: 240.71,
    x2: 698.04,
    y2: 242.05,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M561.43,180.7l-37.22,15.75a5.8,5.8,0,0,0-2.87,8.13l27.37,50.52a5.82,5.82,0,0,0,7.42,2.57l45.25-19.6",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 0.2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 548.56,
    y1: 202.68,
    x2: 566.53,
    y2: 195.17,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 0.2
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 557.68,
    y1: 218.5,
    x2: 575.64,
    y2: 210.99,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 0.2
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 566.79,
    y1: 234.31,
    x2: 584.76,
    y2: 226.81,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 0.2
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M629.38,208.23s-14.83-7.92-2.18-30.74",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 0.2
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 404.13,
    y1: 271.69,
    x2: 477.68,
    y2: 271.69,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 0.2
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M479.66,189.92s13.12-2.61,18.54,12.87c0,0,3.8,10.93-2.55,21.14",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 0.2
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 503.88,
    y1: 299.93,
    x2: 527.5,
    y2: 287.57,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 0.2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 525.3,
    cy: 306.34,
    r: 6.84,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 0.2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 497.69,
    cy: 124.31,
    r: 52.92,
    transform: "translate(57.87 388.33) rotate(-45)",
    fill: "#00A3FF",
    opacity: 0.2
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M497.7,177.94a53.75,53.75,0,1,1,21.13-4.38A53.69,53.69,0,0,1,497.7,177.94Zm0-105.9a52.39,52.39,0,1,0,19.39,3.76A52.14,52.14,0,0,0,497.68,72Z",
    fill: "#00A3FF"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M495.62,180.65a5.48,5.48,0,0,1,2.15-5.92c3.31-2.71,29.38-9.21,29.38-9.21s7.15-1.06,9,3Z",
    fill: "#00A3FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 191.68,
    y: 431.63,
    width: 8.69,
    height: 14.6,
    fill: "#00A3FF"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 239.82,
    cy: 223.84,
    r: 53.24,
    fill: "#00A3FF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M257.17,203.47a8.67,8.67,0,1,1,8.46,8.89h0A8.68,8.68,0,0,1,257.17,203.47Z",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.52,223.81a5.06,5.06,0,1,1,5,5.18h0a5,5,0,0,1-4.93-5.14Z",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.74,239.24a1.88,1.88,0,1,1-1.67,1.67A1.88,1.88,0,0,1,267.74,239.24Z",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M692.28,186.63,693,188a9.16,9.16,0,0,0,3.65,3.65l1.36.75-1.36.76A9.16,9.16,0,0,0,693,196.8l-.75,1.36-.75-1.36a9.13,9.13,0,0,0-3.64-3.65l-1.36-.76,1.36-.75a9.13,9.13,0,0,0,3.64-3.65Z",
    fill: "#00A3FF"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M98.51,390.18l.76,1.37a9.13,9.13,0,0,0,3.65,3.64l1.36.75-1.36.76a9.16,9.16,0,0,0-3.65,3.65l-.76,1.36-.75-1.36a9.26,9.26,0,0,0-3.64-3.65l-1.36-.76,1.36-.75a9.24,9.24,0,0,0,3.64-3.64Z",
    fill: "#00A3FF"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M335.34,335l.38.68a4.64,4.64,0,0,0,1.82,1.83l.7.38-.7.37a4.58,4.58,0,0,0-1.82,1.83l-.38.68L335,340a4.58,4.58,0,0,0-1.82-1.83l-.7-.37.7-.38a4.64,4.64,0,0,0,1.82-1.83Z",
    fill: "#00A3FF"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M635.92,384.42l.38.69a4.58,4.58,0,0,0,1.83,1.82l.68.37-.68.38a4.52,4.52,0,0,0-1.83,1.82l-.38.68-.37-.68a4.62,4.62,0,0,0-1.82-1.82l-.69-.38.69-.37a4.55,4.55,0,0,0,1.82-1.82Z",
    fill: "#00A3FF"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M419.57,187.6l.36.68a4.64,4.64,0,0,0,1.83,1.82l.69.38-.69.37a4.73,4.73,0,0,0-1.83,1.83l-.36.69-.38-.69a4.78,4.78,0,0,0-1.85-1.83l-.7-.37.7-.31a4.62,4.62,0,0,0,1.82-1.82Z",
    fill: "#00A3FF"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M259.12,153.5l.37.68a4.67,4.67,0,0,0,1.82,1.84l.69.36-.69.38a4.64,4.64,0,0,0-1.82,1.83l-.37.68-.38-.68a4.48,4.48,0,0,0-1.83-1.83l-.68-.38.68-.36a4.63,4.63,0,0,0,1.83-1.84Z",
    fill: "#00A3FF"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M397.49,62.29l1.36,2.37a16,16,0,0,0,6.3,6.3l2.37,1.36-2.37,1.36a15.85,15.85,0,0,0-6.3,6.3l-1.36,2.36L396.13,80A15.77,15.77,0,0,0,390,73.54l-2.36-1.36L390,70.82a15.85,15.85,0,0,0,6.3-6.3Z",
    fill: "#00A3FF"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M586.1,537.2l1.29,2.37a15.78,15.78,0,0,0,6.3,6.3l2.37,1.36-2.37,1.3a15.78,15.78,0,0,0-6.3,6.3l-1.29,2.36-1.36-2.36a15.91,15.91,0,0,0-6.3-6.3l-2.37-1.3,2.37-1.36a15.78,15.78,0,0,0,6.3-6.3Z",
    fill: "#00A3FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServerError);
export default __webpack_public_path__ + "static/media/server-error.34daa2b4d6116b95cfe522f50ebec846.svg";
export { ForwardRef as ReactComponent };